import {
    SET_FORM_DATA_FROM_TABLE_EMAIL_GROUP,
    SET_IS_EDITING_EMAIL_GROUP,
    SET_IS_CREATING_EMAIL_GROUP,
    SET_ALL_EMAIL_GROUPS
} from "../actions/types";

const initialState = {
    formDataFromTableEmailGroup: {},
    isEditingEmailGroup: false,
    isCreatingEmailGroup: false,
    allEmailGroups: []
};

const EmailGroupReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_FORM_DATA_FROM_TABLE_EMAIL_GROUP:
            return { ...state, formDataFromTableEmailGroup: payload };

        case SET_IS_EDITING_EMAIL_GROUP:
            return { ...state, isEditingEmailGroup: payload };

        case SET_IS_CREATING_EMAIL_GROUP:
            return { ...state, isCreatingEmailGroup: payload };
        case SET_ALL_EMAIL_GROUPS:
            return { ...state, allEmailGroups: payload }

        default:
            return state;
    }
};

export default EmailGroupReducer;